import React from 'react'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Alert, Button, Col, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import renderField from "./renderField";
import renderCheck from "./renderCheck";
import normalizePhone from "./normalizePhone";

const required = value => value ? undefined : 'Merci de remplir ce champ'

const displayError = (submitFailed) => {

    if (submitFailed) {

        return (
            <Alert color="danger">
                Le formulaire contient des erreurs
            </Alert>
        );
    }

}
const validate = values => {
    const errors = {}
    if (values.reexpedition) {

        if (!values.reexpedition.semaine) {
            errors.reexpedition = 'Merci de remplir ce champ'
        }
        if (!values.reexpedition.adresse) {
            errors.reexpedition = 'Merci de remplir ce champ'
        }

    }
    if (values.notificationSMS) {

        if (!values.telephone) {
            errors.telephone = 'Merci de remplir ce champ'
        } else if (values.telephone.length != 14) {
            errors.telephone = 'Numéro de téléphone invalide'
        }

    }
    return errors
}

const FirstStep = props => {
    let { handleSubmit, formValues, submitFailed } = props;
    if (!formValues) {
        formValues = {};
    }
    let nouveauStyle = { color: '#f38030', display: 'inline-block', 'margin-left': '0.5em', 'font-weight': 'bolder', 'font-size': '0.8em' };

    return (
        <form onSubmit={handleSubmit}>
            {displayError(submitFailed)}
            <FormGroup tag="fieldset">
                <legend style={{ textDecoration: "underline" }}>1/ Quel échelonnement choisissez vous pour votre domiciliation* ?</legend>
                <Row>
                    <Col xs={{ size: 11, offset: 1 }}>
                        <FormGroup check>
                            <Field name="modeReglement" type="radio" value="trim" label="Trimestre 147 € HT" component={renderCheck} validate={required} />
                        </FormGroup>
                        <FormGroup check>
                            <Field name="modeReglement" type="radio" value="sem" label="Semestre 269 € HT (-9%)" component={renderCheck} validate={required} />
                        </FormGroup>
                        <FormGroup check>
                            <Field name="modeReglement" type="radio" value="ann" label="Année 490 € HT (-20%)" component={renderCheck} validate={required} />
                        </FormGroup>
                        <FormText color="muted">
                            *Engagement d'un an
                </FormText>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{ textDecoration: "underline" }}>2/ Quelles options souhaitez-vous ajouter a votre domiciliation ?</legend>
                <Row>
                    <Col xs={{ size: 11, offset: 1 }}>
                        <FormGroup check>
                            <Field name="scanCourrier" type="checkbox" label={<span>Scan Courrier : 39 € HT / mois</span>} component={renderCheck} />
                            <span style={nouveauStyle}>Nouveau</span>
                            <FormText color="muted">Tous les jours, nous scannons et envoyons par email votre courrier.</FormText>
                        </FormGroup>
                        <FormGroup check>
                            <Row>
                                <Col xs="12" sm="6">
                                    <Field name="reexpedition" type="checkbox" label={<span>Réexpédition :</span>} component={renderCheck} />
                                    <FormText color="muted">
                                        Nous réexpédition votre courrier à l’adresse de votre choix.
                            </FormText>
                                </Col>
                                <Col xs="12" sm="6">
                                    <FormGroup check>
                                        <Field name="reexpedition.semaine" type="radio" value="1" disabled={!formValues.reexpedition} label="1 x par semaine : 25 € HT / mois" component={renderCheck} />
                                    </FormGroup>
                                    <FormGroup check>
                                        <Field name="reexpedition.semaine" type="radio" value="2" disabled={!formValues.reexpedition} label="2 x par semaine : 35€ HT / mois" component={renderCheck} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup check hidden={!formValues.reexpedition}>
                            <Row>
                                <Col xs="12" sm={{ size: 8, offset: 4 }}>
                                    <Label>Votre adresse de réexpédition</Label>
                                    <Field name="reexpedition.adresse" type="textarea" component="textarea" className="form-control" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup check>
                            <Field name="notificationSMS" type="checkbox" label={<span>Notification SMS : 10 € HT / mois</span>} component={renderCheck} />
                            <FormText color="muted">
                                Nous vous avertissons en temps réel
                                si vous avez reçu du courrier, un recommandé ou un colis
                    </FormText>
                        </FormGroup>
                        <FormGroup check hidden={!formValues.notificationSMS}>
                            <Label>Votre numéro de téléphone</Label>
                            <Row>
                                <Col sm="6">
                                    <Field name="telephone" component={renderField} className="form-control" normalize={normalizePhone} />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup check>
                            <Field name="numeroGeo" type="checkbox" label={<span>Numéro géographique : 15 € HT / mois + 0,13 cts / min*</span>} component={renderCheck} />
                            <FormText color="muted">
                                Création d’un numéro de téléphone national
                                de la région de votre choix (01,02,03,04,05)
                                et renvoi des appels entrants de ce numéro vers votre numéro de portable
                    </FormText>
                        </FormGroup>
                        <FormGroup check>
                            <Field name="permanenceTel" type="checkbox" label={<span>Permanence téléphonique : 50 € HT / mois + 0,99 € HT / appel*</span>} component={renderCheck} />
                            <FormText color="muted">
                                Nous assurons la permanence téléphonique de votre entreprise en répondant
                                aux appels de vos clients sans interruption. Call and Co place les entreprises
                                au cœur de son métier et fait du maintien de votre image de marque sa grande priorité.
                    </FormText>
                        </FormGroup>
                        <FormText color="muted" className="text-center">
                            <strong>
                                (Pour une offre personnalisée contactez nos experts ASEI
                        ou rendez-vous sur <a href="http://www.callandco.fr">www.callandco.fr</a> )
                    </strong>
                        </FormText>
                    </Col>
                </Row>
            </FormGroup>
            <div>
                <Button type="submit" className="float-right">
                    Prochaine Etape
                </Button>
            </div>
        </form>
    )
}

function mapStateToProps(state) {
    return {
        formValues: getFormValues('wizard')(state),
    }
}

export default connect(mapStateToProps, null)(reduxForm({
    form: 'wizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
    onSubmitFail: (errors) => window.scrollTo(0, 0),
})(FirstStep));


// WEBPACK FOOTER //
// ./src/FirstStep.js